export enum PlasterTexture {
    baranek,
    kornik,
    invalid
}